import { useQuery } from 'react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type { SearchData } from '../common';
import { getUseSearchSharesQueryKey, UseSearchSharesQueryKey } from './keys';
import type { UseSearchSharesParams } from './types';

export const useSearchShares: QueryFunction<
  SearchData,
  [body: UseSearchSharesParams],
  UseSearchSharesQueryKey
> = (body, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useQuery({
    ...queryOptions,
    queryKey: getUseSearchSharesQueryKey(body),
    queryFn: ({ signal }) =>
      request('/search/shared_with_me', {
        init: {
          signal,
          method: 'POST',
          body: { ...body },
        },
      }),
  });
};
